import { useEffect, useState } from 'react';
import { httpGet } from '../../../utils';
import { Policy } from '../../../../types/policies';
import { PolicyConfiguration } from '../../types/PolicyConfiguration';
import { POLICIES_BASE_URL } from '../consts';

interface RulesData {
    Rules: Policy[];
    PolicyConfiguration: PolicyConfiguration;
}

export const useGetRulesData = () => {
    const [error, setError] = useState<unknown | undefined>();
    const [loading, setLoading] = useState(false);
    const [rulesData, setRulesData] = useState<RulesData | undefined>();

    const fetchRules = async () => {
        setLoading(true);

        try {
            const response = await httpGet(`${POLICIES_BASE_URL}/rules`);
            if (response?.data !== null) {
                setRulesData(response.data as RulesData);
            } else {
                throw new Error('Failed to fetch rules data');
            }
        } catch (error: unknown) {
            setError(error);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchRules();
    }, []);

    return {
        error,
        loading,
        rulesData
    };
};
